import BaseFeature from '../../foundation/base/base';


class Search extends BaseFeature {
	constructor(element) {
		super(element);

		this.initDomCache();

		this.el = element;
		this.lastKnownScrollY = 0;
		this.currentScrollY = 0;
		this.ticking = false;
		this.search = this.el;
		this.body = window.features.dom.body;
		this.searchBtnOpen = this.el.querySelector('[data-js="searchBtnOpen"]');
		this.searchBtnClose = this.el.querySelector('[data-js="searchBtnClose"]');
		this.searchInput = this.el.querySelector('[data-js="searchInput"]');

		this.addClick();
		this.log('Search');
	}


	addClick() {
		if (this.searchBtnOpen) {
			this.searchBtnOpen.addEventListener('click', () => {
				// Collapsing menu if search is triggered
				const menuTrigger = document.querySelector('.m-menu-list__item.is-active');
				if (menuTrigger) {
					menuTrigger.classList.remove('is-active');
				}
				this.searchBtnOpen.parentNode.parentNode.classList.add('is-active');
				this.searchBtnOpen.setAttribute('aria-expanded', 'true'); // Accessibility
				this.searchBtnClose.setAttribute('aria-expanded', 'true'); // Accessibility
				this.searchInput.focus();
			});
			// Accessibility
			window.addEventListener('keyup', (e) => {
				const isFocused = document.activeElement === this.searchBtnOpen;
				if (isFocused && e.keyCode === 13) {
					e.preventDefault();
					// Trigger the button element with a click
					this.searchBtnOpen.click();
				}
			});
		}

		if (this.searchBtnClose) {
			this.searchBtnClose.addEventListener('click', () => {
				this.searchBtnOpen.parentNode.parentNode.classList.remove('is-active');
				this.searchBtnOpen.setAttribute('aria-expanded', 'false'); // Accessibility
				this.searchBtnClose.setAttribute('aria-expanded', 'false'); // Accessibility
				this.searchInput.blur();
			});
			// Accessibility
			window.addEventListener('keyup', (e) => {
				const isFocused = document.activeElement === this.searchBtnClose;
				if (isFocused && e.keyCode === 13) {
					e.preventDefault();
					// Trigger the button element with a click
					this.searchBtnClose.click();
				}
			});
		}
	}
}

export default Search;
